import { useEffect, useState } from "react";
import "../global/basic.css"
import { API_URL } from "../shared/api";
import { useNavigate } from "react-router-dom";
import useBackupUser from "../shared/hooks/useBackupUser";
import MainComponent from "../global/mainlayout/MainComponent";


export default function GamesPage() {
  const navigate = useNavigate();

  const user = useBackupUser();

  const [games, setGames] = useState([]);
  const [activeGame, setActiveGame] = useState(undefined);


  useEffect(() => {
    if(!user)
      return

    fetch(`${API_URL}/users/${user?.id}/active-game`, {method: "GET"})
      .then(r => r.json())
      .then(setActiveGame)
      .catch(e => console.log("no active game."))

    fetch(`${API_URL}/users/${user?.id}/games`, {method: "GET"})
      .then(r => r.json())
      .then(x => [...x].sort((a,b) => b.name.localeCompare(a.name)))
      .then(setGames)
  }, [user?.id, user])


  return (
    <MainComponent title="Vergangene Spiele">
    
      <div>
        {games.length > 0
        ? <div className="vertical-container center">
          <table className="top-margin hoverable"><tbody>
            {games.map((g, i) => 
              <tr key={g.id} onClick={() => navigate(`./${g.id}`, { state: { user: user, game: g } })}><td className="padding" >
                <span className={g.id === activeGame?.id ? "marked secondary" : ""}>
                  {g.name}
                </span>
              </td></tr>
            )}
          </tbody></table>
          </div>
        : <div>Keine Spiele.</div>
        }
      </div>

    </MainComponent>
  );
}